
import dust from "dustjs-linkedin";


(function(){dust.register("grammar-tips/hint",body_0);function body_0(chk,ctx){return chk.write("<div class=\"content-item\" data-key=\"").reference(ctx.get(["key"], false),ctx,"h").write("\"><header>").reference(ctx.get(["title"], false),ctx,"h",["s"]).write("</header><main>").reference(ctx.get(["html"], false),ctx,"h",["s"]).write("</main></div>");}return body_0;})();

export default 0;
